import { UPDATE_NAVS } from './navigationTypes';

export const updateNavs = navs =>{
    return{
        type: UPDATE_NAVS,
        payload: navs
    }
}